import { FC, ReactNode, useCallback } from 'react';
import styled from 'styled-components';

interface GridRowProps {
  children: ReactNode;
  index: number;
  fieldId: string;
  isLoading: boolean;
  removeRow?: (rowIndex: number) => void;
}

const StyledDiv = styled.div`
  gap: 0.5rem;
`;
export const GridRow: FC<GridRowProps> = ({ index, children, fieldId, isLoading, removeRow }) => {
  const canRemoveRow = removeRow !== undefined;
  const onClick = useCallback(() => removeRow!(index), [index, removeRow]);
  return (
    <StyledDiv className="flex-grow-1 d-flex flex-row flex-wrap mb-2" data-e2e={fieldId + '-item'}>
      {children}
      {canRemoveRow && (
        <button
          className="btn btn-icon"
          disabled={isLoading}
          onClick={onClick}
          type="button"
          data-e2e={fieldId + '-item-close'}
        >
          <i className="clickable icon text-secondary">delete</i>
        </button>
      )}
      {isLoading && <div className="spinner-border spinner-border-sm text-light flex-shrink-0 flex-grow-0" />}
    </StyledDiv>
  );
};
